import { render, staticRenderFns } from "./SafeAddRemove.template.vue?vue&type=template&id=a8ca5eb6&scoped=true&"
var script = {}
import style0 from "./SafeAddRemove.template.vue?vue&type=style&index=0&id=a8ca5eb6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8ca5eb6",
  null
  
)

export default component.exports